export default __webpack_public_path__ + "static/media/kn.240df9de.svg";